import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const FeedBack = React.lazy(() => import("./FeedBack"));
const FeedBackThankyou = React.lazy(() =>
    import("./FeedBackQrForm/FeedBackThankyou")
);
const UserFeedBack = React.lazy(() => import("./UserFeedBack"));
const FeedbackResponse = React.lazy(() => import("./FeedBackResponse"));
const AreaMaster = React.lazy(() => import("./AreaMaster/index"));
const FeedBackDetails = React.lazy(() => import("./FeedBackDetail"));
const FeedBackQrCode = React.lazy(() => import("./FeedBackQrForm/QrCodeForm"));
export const FeedBackConfigs = [
    {
        permittedRole: [RoutePermittedRole.SUPER_ADMIN],
        path: "/feedback",
        element: <FeedBack />,
    },
    {
        permittedRole: [RoutePermittedRole.SUPER_ADMIN],
        path: "/feedback-area-master",
        element: <AreaMaster />,
    },
    {
        permittedRole: [RoutePermittedRole.SUPER_ADMIN],
        path: "/feedback-details/:locationId/:feedBackAreaId",
        element: <FeedBackDetails />,
    },
    {
        permittedRole: [RoutePermittedRole.ADMIN, RoutePermittedRole.SUPER_ADMIN],
        path: "/feedback-response",
        element: <FeedbackResponse />,
    },
    {
        permittedRole: [RoutePermittedRole.ADMIN, RoutePermittedRole.SUPER_ADMIN],
        path: "/feedback-response/:locationId/:feedBackAreaId",
        element: <UserFeedBack />,
    },
];
export const feedBackConfigPublic = [
    {
        path: "/feedback-user/:locationId/:feedBackAreaId",
        element: <FeedBackQrCode />,
    },
    {
        path: "/feedback-thankyou",
        element: <FeedBackThankyou />,
    },
];
